import FilterDrawer from "./_components/filter-drawer.component";
import BreadCrumbWithBack from "@/components/v-pos/bread-crumb-with-arrow-back";
import TransactionCard from "./_components/transaction-card";
import { useGetVirtualPosAllByShopIdQuery } from "@/lib/services/data-layer/core";
import { Loader } from "@/components/v-pos/loader.component";
import PaginationApi from "@/components/v-pos/pagination-api.component";
import { IoClose } from "react-icons/io5";
import { isAnyStringFieldValid, formatPersianDate } from "@/lib/helper";
import { Button } from "@/components/ui/button";
import { useUrlFilters } from "@/lib/hooks";
import { filterType } from "./_type/filter.type";

const TransactionReport = () => {
  const shopId = localStorage.getItem("agent_shop_id");

  const {
    filters: { page, ...filters },
    updateFilters,
  } = useUrlFilters<filterType>({ page: 1 });

  const { data, isLoading, error } = useGetVirtualPosAllByShopIdQuery({
    shopId: shopId ?? undefined,
    ...filters,
    page,
  });

  return (
    <div className="flex flex-col w-full p-[20px] space-y-[18px] min-h-custom-screen">
      <BreadCrumbWithBack
        data={[]}
        hasBack
        linkBack="/"
        className="mb-[20px]"
      />
      <div className="w-full flex items-center justify-between border-b mb-[15px] border-[#EEEEEE]pb-1">
        <p className="font-bold text-lg">گزارش لینک های ارسال شده</p>
        <span className="text-xs flex gap-1">
          <FilterDrawer
            key={JSON.stringify(filters)}
            filterProps={filters}
            setFilterProps={updateFilters}
          />
        </span>
      </div>
      {isAnyStringFieldValid(filters) && (
        <div className="flex flex-wrap gap-[10px] mb-5">
          {Object.entries(filters).map(([key, value]) => {
            if (value === "") return null;

            return (
              <Button
                className="bg-[#F3F3F3] text-sm hover:bg-[#F3F3F3] text-foreground flex rounded-[6px] h-[34px] items-center !pr-[0px] !pl-[10px]"
                key={key}
                onClick={() => {
                  updateFilters({
                    [key]: "",
                  });
                }}
              >
                <IoClose color="#BB1515" className="text-3xl" />
                <span className="mt-0.5">
                  {key === "createdAt"
                    ? formatPersianDate({ dateString: value, mode: "onlyDate" })
                    : value}
                </span>
              </Button>
            );
          })}
        </div>
      )}
      {isLoading && (
        <div className="w-full flex justify-center items-center">
          <Loader />
        </div>
      )}
      {data &&
        (data?.items?.length !== 0 ? (
          <>
            <div className="flex-grow space-y-[8px]">
              {data?.items?.map((item) => (
                <TransactionCard key={item.id} {...item} />
              ))}
            </div>
            <PaginationApi
              pageIndex={page}
              setPageIndex={(page) => updateFilters({ page })}
              data={data}
              isLoading={isLoading}
              className="mt-[25px]"
              config={{
                maxVisiblePages: 1,
                showEllipsis: true,
              }}
            />
          </>
        ) : (
          <div className="w-full flex justify-center items-center">
            <span className="text-[#777777] ">هیچ موردی یافت نشد</span>
          </div>
        ))}
      {error && (
        <div className="w-full flex justify-center items-center mt-[90px]">
          <span className="text-red-700">
            {error?.message ?? "مشکلی رخ داده است."}
          </span>
        </div>
      )}
    </div>
  );
};

export default TransactionReport;
